import { CheckIcon } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space, zIndices, fontSizes } = theme

export const Hero = styled.section`
  background-color: ${colors['neutral-background-default']};
  padding-top: ${space['spacing-lg']};
  padding-bottom: ${space['spacing-lg']};
`

export const ImageWrapper = styled.div`
  width: 100%;
  margin-bottom: ${space['spacing-md']};
`

export const Infos = styled.div`
  position: relative;
  z-index: ${zIndices[1]};

  h1 {
    margin-bottom: ${space['spacing-lg']};
  }

  > p {
    margin-bottom: ${space['spacing-md']};
  }

  @media (${media.tablet}) {
    top: 32px;
    margin-bottom: ${space['spacing-md']};

    .ds-button {
      width: 19rem;
    }
  }

  @media (${media.desktop}) {
    h1,
    h1 span {
      font-size: ${fontSizes['font-size-heading-2']};
    }

    > p {
      font-size: ${fontSizes['font-size-body-1']};
    }
  }
`

export const LoanInfos = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${space['spacing-md']};
  margin-top: ${space['spacing-md']};

  @media (${media.tablet}) {
    grid-template-columns: 1fr;
    gap: ${space['spacing-sm']};
    margin-bottom: ${space['spacing-xl']};
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-md']};
  }
`

export const LoanInfosItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};

  p {
    color: ${colors['neutral-text-weak']};
    font-size: ${fontSizes['font-size-body-1']};
  }
`

export const LoanInfosIcon = styled(CheckIcon)`
  margin-bottom: ${space['spacing-xxs']};

  @media (${media.tablet}) {
    margin-bottom: 0;
  }
`
